import { Deserializable } from "../deserializable";

export class IdiomasInfoI18N implements Deserializable {
  CodIdioma: string;
  Nombre: string;
  Titulo: string;
  Parrafo1: string;
  Parrafo2: string;
  Parrafo3: string
  Horario1: string
  Horario2: string
  Horario3: string
  Horario4: string
  TextoAmigable: string
  Copyright: string
  MetaDescription: string
  Ubicacion: string
  URLExterna:string;
  Tipo?:string;
  TipoPublico?:string

  public IdiomasInfoI18N(codidioma: string, titulo:string, parrafo1:string, parrafo2:string) {
    this.CodIdioma = codidioma;
    this.Titulo = titulo;
    this.Parrafo1 = parrafo1;
    this.Parrafo2 = parrafo2;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}